import React, { MouseEventHandler, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import { useAppDispatch, useAppSelector } from "../../store/store";
import "../../css/testCenter.css";
import { useGetTestQuestionsMutation } from "../../store/testCenterSlice";
import { Button } from "antd";

interface CameraTestDescriptionType {
  onCloseDescriptionModal: MouseEventHandler<HTMLElement>;
  companyName: string;
  companyTitle: string;
  interviewDate: string;
  locationAddress: string;
}

function LocationDescription(props: CameraTestDescriptionType) {
  const {
    onCloseDescriptionModal,
    companyName,
    companyTitle,
    interviewDate,
    locationAddress,
  } = props;

  return (
    <div className="test_center__content" style={{ marginTop: "30px" }}>
      <div className="test_description_card_content_wrapper">
        <div className="test_description_card_content">
          <div className="test_description_card_content_text">
            <div
              style={{
                marginBottom: "30px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <text>Company Name:</text>
              <text style={{ color: "grey", fontWeight: "500" }}>
                During the assessment test, we will require access to your
                device's camera to capture snapshots. This is essential for
                verifying your identity and maintaining the integrity of the
                assessment process.
              </text>
            </div>
          </div>
          <div className="test_description_card_content_text">
            <div
              style={{
                marginBottom: "30px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <text>Company Title:</text>
              <text style={{ color: "grey", fontWeight: "500" }}>
                During the assessment test, we will require access to your
                device's camera to capture snapshots. This is essential for
                verifying your identity and maintaining the integrity of the
                assessment process.
              </text>
            </div>
          </div>
          <div className="test_description_card_content_text">
            <div
              style={{
                marginBottom: "30px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <text>Interview Date:</text>
              <text style={{ color: "grey", fontWeight: "500" }}>
                During the assessment test, we will require access to your
                device's camera to capture snapshots. This is essential for
                verifying your identity and maintaining the integrity of the
                assessment process.
              </text>
            </div>
          </div>
          <div className="test_description_card_content_text">
            <div
              style={{
                marginBottom: "30px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <text>Location:</text>
              <text style={{ color: "grey", fontWeight: "500" }}>
                During the assessment test, we will require access to your
                device's camera to capture snapshots. This is essential for
                verifying your identity and maintaining the integrity of the
                assessment process.
              </text>
            </div>
          </div>
          <div className="start_test_btn">
            <Button
              type="primary"
              htmlType="submit"
              style={{ width: "100%" }}
              onClick={onCloseDescriptionModal}
            >
              Got it!
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LocationDescription;
